import React, { Fragment, useState, useEffect, useContext } from "react";
import StickyISI from "../../../skicky-isi";
import { appContext } from "providers/appProvider";
import { useLocation } from "@reach/router";
import FullIsi from "./isi-contents/hcp-isi";
import AnchorLink from "react-anchor-link-smooth-scroll";
import useDeviceSize from "../../../../hooks/useDeviceSize";

export default function Isi({ footerRef, indication, reference }) {
    const { appConfigs, topOffset, magicshot } = useContext(appContext);
    const [isSticky, setIsSticky] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const [popupClosed, setPopupClosed] = useState(false); // State to track if the popup has been closed
    const deviceSizes = useDeviceSize();
    const location = useLocation();

    useEffect(() => {
        // Check if the sticky option should be enabled
        if (
            appConfigs.siteOptions.ISI_OPTIONS.TYPE === "sticky" &&
            !magicshot
        ) {
            setIsSticky(true);
        }

        // Update sticky heights based on device width
        const deviceWidth = window.innerWidth;
        if (deviceWidth < 361) {
            appConfigs.siteOptions.STICKY_HEIGHT = 180;
            appConfigs.siteOptions.ISI_OPTIONS.STICKY_STYLES.height = 200;
        } else if (deviceWidth < 415) {
            appConfigs.siteOptions.STICKY_HEIGHT = 180;
            appConfigs.siteOptions.ISI_OPTIONS.STICKY_STYLES.height = 190;
        } else if (deviceWidth < 431) {
            appConfigs.siteOptions.ISI_OPTIONS.STICKY_STYLES.height = 170; // for device widths less than 430
        } else {
            appConfigs.siteOptions.ISI_OPTIONS.STICKY_STYLES.height = 205; // for device widths greater than 390
        }
    }, [
        appConfigs.siteOptions.ISI_OPTIONS.TYPE,
        magicshot,
        deviceSizes.smDown,
    ]);

    // Simulate a method to set popupClosed to true once popups are confirmed to be closed
    useEffect(() => {
        const checkPopupStatus = () => {
            setTimeout(() => setPopupClosed(true), 1000); // Simulate a delay for popup closure
        };

        checkPopupStatus(); // Call the function to check popup status
    }, []);

    useEffect(() => {
        const scrollToIsi = () => {
            const isiElement = document.getElementById("isiContainer");
            if (isiElement && popupClosed) {
                isiElement.scrollIntoView({ behavior: "smooth" });
            }
        };

        if (location.hash === "#isiContainer") {
            setTimeout(scrollToIsi, 100); // Delay a bit to ensure popups are handled first
        }
    }, [location.hash, popupClosed]);

    return (
        <Fragment>
            {isSticky ? (
                <StickyISI
                    footerRef={footerRef}
                    stickyHeight={appConfigs.siteOptions.STICKY_HEIGHT}
                    stickyStyles={
                        appConfigs.siteOptions.ISI_OPTIONS.STICKY_STYLES
                    }
                    className="isi"
                    onFooterStateChange={(result) => {
                        setIsExpanded(result);
                    }}
                >
                    <div className="isi-content-wrapper">
                        <div className="isi-content">
                            {!isExpanded && (
                                <AnchorLink
                                    href="#isiContainer"
                                    className="btn-expand-isi"
                                    offset={topOffset}
                                    aria-label="Expand information"
                                    tabIndex="0"
                                    aria-expanded={isExpanded}
                                    aria-controls="isi-Container"
                                >
                                    <span className="btn-expand-text">
                                        <svg
                                            width={30}
                                            height={30}
                                            viewBox="0 0 30 30"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                        >
                                            <path
                                                id="Union"
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M15 0C13.8954 0 13 0.89543 13 2V13H2C0.89543 13 0 13.8954 0 15C0 16.1046 0.89543 17 2 17H13V28C13 29.1046 13.8954 30 15 30C16.1046 30 17 29.1046 17 28V17H28C29.1046 17 30 16.1046 30 15C30 13.8954 29.1046 13 28 13H17V2C17 0.895431 16.1046 0 15 0Z"
                                                fill="#212D5E"
                                            />
                                        </svg>
                                        <span className="visually-hidden">
                                            {isExpanded ? "Collapse" : "Expand"}{" "}
                                            Important Safety Information
                                        </span>
                                    </span>
                                </AnchorLink>
                            )}
                            <FullIsi
                                reference={reference}
                                expanded={isExpanded}
                            />
                        </div>
                    </div>
                </StickyISI>
            ) : (
                <div className="isi">
                    <div className="isi-content-wrapper">
                        <div className="isi-content">
                            <FullIsi
                                reference={reference}
                                expanded={isExpanded}
                            />
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
}
